import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Link from '@cotyorg/ccx-atoms/Link';
import Picture from '@cotyorg/ccx-atoms/Picture';

const HeroImageWrapper = ({ imageHasLink, links, children }) => (
  imageHasLink && Array.isArray(links) ? (
    <Link link={R.path([0, 'url'], links)}>{children}</Link>
  ) : (
    children
  )
);

HeroImageWrapper.propTypes = {
  imageHasLink: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  })),
  children: PropTypes.node,
};

const HeroImage = ({
  imageSrc,
  alt = '',
  imageSrcSet,
  heroImageClassName,
  heroSecondaryImageClassName,
  imageSecondarySrc,
  imageSecondaryAlt,
  imageSecondarySrcSet,
  imageHasLink,
  links,
  heroTag,
}) => (
  <Fragment>
    {imageSecondarySrc &&
      <div className={heroSecondaryImageClassName}>
        <HeroImageWrapper
          imageHasLink={imageHasLink}
          links={links}
        >
          <Picture
            src={imageSecondarySrc}
            srcset={imageSecondarySrcSet}
            alt={imageSecondaryAlt}
          />
        </HeroImageWrapper>
      </div>
    }
    <div className={heroImageClassName}>
      <HeroImageWrapper
        imageHasLink={imageHasLink}
        links={links}
      >
        <Picture
          src={imageSrc}
          srcset={imageSrcSet}
          alt={alt}
        />
      </HeroImageWrapper>
      {heroTag && (
        <div className="hero__tag">
          {heroTag}
        </div>
      )}
    </div>
  </Fragment>
);

HeroImage.propTypes = {
  imageSrc: PropTypes.string,
  alt: PropTypes.string,
  imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  heroImageClassName: PropTypes.string,
  heroSecondaryImageClassName: PropTypes.string,
  imageSecondarySrc: PropTypes.string,
  imageSecondaryAlt: PropTypes.string,
  imageSecondarySrcSet: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  heroTag: PropTypes.string,
};

export default HeroImage;
